import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import numberFormat from "../../common/numberFormat";
import api from "../../config/api";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getEmployees } from "../../stores/EmployeeStore";

const formInit = {
  date: new Date(),
  employee: "",
  amount: "",
  invoice: "",
  comment: "",
};
export default function PaySalaryModel() {
  const queryClient = useQueryClient();

  const { data: categories } = useQuery({
    queryFn: () => getEmployees(),
    queryKey: ["employees"],
  });

  const Body = ({ onDone }) => {
    const [disabled, setDisabled] = useState(false);
    const [form, setForm] = useState(cloneDeep(formInit));

    const handleSubmit = async (event) => {
      event.preventDefault();
      if (!form.employee) {
        document.querySelector("#employee input").focus();
        return false;
      }

      setDisabled(true);
      const res = await api.post("salary", {
        ...form,
      });
      if (!res.ok) {
        setDisabled(false);
        toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["salary"]);

      setForm(formInit);
      setDisabled(false);
      toast.success("Salary has been successfully paid.");

      onDone && onDone();
    };
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };
    return (
      <form id="form" onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <span className="d-flex" style={{ alignItems: "center" }}>
            <b>Pay Salary</b>
          </span>
        </Modal.Header>
        <br />
        <br />
        <div
          className="d-flex"
          style={{
            gap: "0px 30px",
            padding: "0px 30px",
            alignItems: "flex-start",
            // minHeight: 400,
          }}
        >
          <AppInput
            type="date"
            name="date"
            placeholder="Date"
            label="Date"
            floatLabel
            value={form.date}
            onChange={handleChange}
            required
          />
          <AppInput
            type="dropdown"
            name="employee"
            id="employee"
            value={form.employee}
            onChange={handleChange}
            label="Employee"
            filterBy="name"
            floatLabel
            containerStyle={{ height: 90 }}
            options={categories?.map((i) => ({ ...i, name: i.name }))}
          />
          <AppInput
            name="amount"
            value={numberFormat(form.amount)}
            onChange={handleChange}
            required
            label="Amount"
            floatLabel
            containerStyle={{ height: 90 }}
          />
          <AppInput
            name="comment"
            value={form.comment}
            onChange={handleChange}
            required
            label="Comment"
            floatLabel
            containerStyle={{ height: 90 }}
          />
        </div>
        <br />
        <br />
        <br />
        <br />
        <Modal.Footer>
          <AppButton
            disabled={disabled}
            text="Pay Salary"
            form="form"
            type="submit"
            className="text-primary btn-light"
          />
        </Modal.Footer>
      </form>
    );
  };

  return {
    Body,
  };
}
